<template>
  <div class="search-form" :class="{ 'search-form--embedded': embedded }">
    <div class="o-layout o-layout--gutter-small o-layout--bottom o-layout--fix u-text-align--left">
      <div
        :class="`o-layout__item u-1/${
          isStateForm ? '6' : '5'
        }@xs pb-20`"
      >
        <div class="c-sb-input">
          <label class="ui-outputlabel ui-widget c-sb-input__label">
            <span class="ui-outputlabel-label">{{ $func.parseIso("country") }}</span>
          </label>
          <div class="c-sb-input__addicon c-sb-input__addicon--drop">
            <select
              size="1"
              class="c-sb-input__field dev-select-country"
              v-model="country"
              @change="checkCountry"
              :disabled="countries.length === 0"
            >
              <option :value="null">{{ $func.parseIso("countrySelected") }}</option>
              <option :value="item.Country" v-for="item in countries" :key="item.Country">
                {{ item.Country }}
              </option>
            </select>
            <i class="c-sb-input__icon fa-light fa-map-marker-alt"></i>
          </div>
        </div>
      </div>

      <div
        :class="`o-layout__item u-1/${
          isStateForm ? '6' : '5'
        }@xs pb-20`"
        v-if="country && (country === 'USA' || country === 'Canada')"
      >
        <div class="c-sb-input">
          <label class="ui-outputlabel ui-widget c-sb-input__label">
            <span class="ui-outputlabel-label">{{ $func.parseIso("state") }}</span>
          </label>
          <div class="c-sb-input__addicon c-sb-input__addicon--drop">
            <select
              size="1"
              class="c-sb-input__field dev-select-country"
              v-model="state"
              @change="checkState"
              :disabled="states.length === 0"
            >
              <option :value="null">{{ $func.parseIso("stateSelected") }}</option>
              <option :value="item.CODIGO" v-for="item in states" :key="item.CODIGO">
                {{ item.NOMBRE_ESTADO }}
              </option>
            </select>
            <i class="c-sb-input__icon fa-light fa-map-marker-alt"></i>
          </div>
        </div>
      </div>

      <div
        :class="`o-layout__item u-1/${
          isStateForm ? '6' : '5'
        }@xs pb-20`"
      >
        <div class="c-sb-input">
          <label class="ui-outputlabel ui-widget c-sb-input__label">
            <span class="ui-outputlabel-label">{{ $func.parseIso("city") }}</span>
          </label>
          <div class="c-sb-input__addicon c-sb-input__addicon--drop">
            <select
              size="1"
              class="c-sb-input__field dev-select-country"
              v-model="city"
              @change="checkMonths"
              :disabled="cities.length === 0"
            >
              <option :value="null">{{ $func.parseIso("citySelected") }}</option>
              <option :value="'all'">{{ $func.parseIso("allCity") }}</option>
              <option :value="item.City" v-for="item in cities" :key="item.City">
                {{ item.City }}
              </option>
            </select>
            <i class="c-sb-input__icon fa-light fa-map-marker-alt"></i>
          </div>
        </div>
      </div>

      <div
        :class="`o-layout__item u-1/${
          isStateForm ? '6' : '5'
        }@xs pb-20`"
      >
        <div class="c-sb-input">
          <label class="ui-outputlabel ui-widget c-sb-input__label">
            <span class="ui-outputlabel-label">{{ $func.parseIso("checkIn") }}</span>
          </label>
          <div class="c-sb-input__addicon c-sb-input__addicon--drop">
            <select
              size="1"
              class="c-sb-input__field dev-select-country"
              v-model="checkIn"
              :disabled="checkInList.length === 0"
            >
              <option :value="null">{{ $func.parseIso("checkIn") }}</option>
              <option :value="item" v-for="item in checkInList" :key="item">
                {{ formatDate(item) }}
              </option>
            </select>
            <i class="c-sb-input__icon fa-light fa-map-marker-alt"></i>
          </div>
        </div>
      </div>

      <div
        :class="`o-layout__item u-1/${
          isStateForm ? '6' : '5'
        }@xs pb-20`"
      >
        <div class="c-sb-input">
          <label class="ui-outputlabel ui-widget c-sb-input__label">
            <span class="ui-outputlabel-label">{{ $func.parseIso("checkOut") }}</span>
          </label>
          <div class="c-sb-input__addicon c-sb-input__addicon--drop">
            <select
              size="1"
              class="c-sb-input__field dev-select-country"
              v-model="checkOut"
              :disabled="!checkIn"
            >
              <option :value="null">{{ $func.parseIso("checkOut") }}</option>
              <option :value="item" v-for="item in checkOutList" :key="item">
                {{ formatDate(item) }}
              </option>
            </select>
            <i class="c-sb-input__icon fa-light fa-map-marker-alt"></i>
          </div>
        </div>
      </div>

      <div
        :class="`o-layout__item u-1/${
          isStateForm ? '6' : '5'
        }@xs u-1/${isStateForm ? '6' : '5'}@md pb-20`"
      >
        <a
          class="c-sb-input__button c-button continuar bg-clr--brand u-1/1 call-pp-help dev-holidays-search-btn"
          @click="submit"
          :style="btnColor ? `background-color: #${btnColor} !important` : ''"
        >
          {{ $func.parseIso("find") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { setSearchWeekObject } from "../utils/sesions";

export default {
  props: {
    embedded: { type: Boolean, default: false },
    btnColor: { type: String, default: null },
  },
  data() {
    return {
      country: null,
      state: null,
      city: null,
      checkIn: null,
      checkOut: null,
      countries: [],
      states: [],
      cities: [],
      checkInList: [],
      checkOutList: [],
    };
  },
  computed: {
    isStateForm() {
      return this.country === "USA" || this.country === "Canada";
    },
  },
  async created() {
    await this.listCountries();
  },
  methods: {
    async listCountries() {
      try {
        const { data } = await this.$axios.get("/week/countries");
        this.countries = data.countries.sort((a, b) =>
          a.Country === "USA" ||
          a.Country === "Mexico" ||
          a.Country === "Dominican Republic"
            ? -1
            : 0,
        );
      } catch (error) {
        console.log(error);
      }
    },
    async listState() {
      try {
        const { data } = await this.$axios.get(
          `/week/states?country=${this.country}`,
        );
        this.states = data.states.sort((a, b) =>
          a.NOMBRE_ESTADO > b.NOMBRE_ESTADO
            ? 1
            : a.NOMBRE_ESTADO < b.NOMBRE_ESTADO
              ? -1
              : 0,
        );
      } catch (error) {
        console.log(error);
      }
    },
    async listCities(state = null) {
      try {
        let query = `?country=${this.country}`;
        if (state) query += `&state=${state}`;
        const { data } = await this.$axios.get(`/week/cities${query}`);
        this.cities = data.cities;
      } catch (error) {
        console.log(error);
      }
    },
    async checkMonths() {
      if (this.country && this.city) {
        try {
          const { data } = await this.$axios.get(
            `/week/check-months?country=${this.country}&city=${this.city}`,
          );
          this.checkInList = data.checkIn;
          this.checkOutList = data.checkOut;
        } catch (error) {
          console.log(error);
        }
      }
    },
    checkCountry() {
      if (this.country) {
        if (this.isStateForm) this.listState();
        else this.listCities();
      }
    },
    checkState() {
      if (this.country && this.state) this.listCities(this.state);
    },
    formatDate(date) {
      return this.$moment(date).format("MMMM - YYYY");
    },
    submit() {
      if (this.country && this.city && this.checkIn && this.checkOut) {
        setSearchWeekObject({
          country: this.country,
          city: this.city,
          checkIn: this.checkIn,
          checkOut: this.checkOut,
          state: this.state,
        });
        this.$emit("search", {
          country: this.country,
          state: this.state,
          city: this.city,
          checkIn: this.checkIn,
          checkOut: this.checkOut,
        });
      }
    },
  },
};
</script>

<style scoped>
.search-form--embedded {
  padding: 16px;
}
</style>